module.exports = __webpack_public_path__ + "static/nilanjana-roy-49e5b2919ddddf70c941d9bbbd2e66ef.jpg";